import { FC } from "react";

type MinMax = {
  min: number;
  max: number;
};

export type TariffsData = {
  kuper: MinMax | null;
  kuper_auto: MinMax | null;
  eda_car: MinMax | null;
  eda_velo: MinMax | null;
  c_cargo: MinMax | null;
  c_courier: MinMax | null;
  c_express: MinMax | null;
  c_express_30min_longer: MinMax | null;
  t_express: MinMax | null;
  t_econom: MinMax | null;
  t_business: MinMax | null;
  t_courier: MinMax | null;
  t_comfortplus: MinMax | null;
  t_vip: MinMax | null;
  t_minivan: MinMax | null;
};

export type PaymentMethod = {
  payment_method_id: string;
  is_selected: boolean;
  card_metadata: {
    first6: string | null;
    last4: string | null;
    issuer_name: string | null;
    card_type: string | null;
  };
};

export type PriceRangesI = {
  ranges: TariffsData;
  name: string;
  id: number;
};

export type AgglomerationsPriceRanges = {
  global_ranges: TariffsData;
  agglomerations: [
    {
      id: number;
      name: string;
      ranges: TariffsData;
    }
  ];
};

export type HexGroupI = {
  id: number;
  name: string;
  is_eda_active?: boolean;
  center: {
    lat: number;
    lon: number;
  };
  bounds: [number, number, number, number];
  tariffs_data: TariffsData;
};

export type AgglomerationI = {
  id: number;
  name: string;
  center: {
    lat: number;
    lon: number;
  };
  bounds: [number, number, number, number];
  hexgroups: HexGroupI[];
};

export type UserI = {
  telegram_id: number;
  dc_person_id: number | null;
  mail: string | null;
  hexgroup_id: number;
  agglomeration_id: number;
  funnel_status: UserFunnelStatus | null;
  app_version: string;
  referral_blogger_yandex_id: string | null;
  promocode: string | null;
  promocode_modal_shown: boolean;
  cancelled_subscription: boolean;
  subscription_ends_at: string;
  subscription_price: number;
  selected_activate_option: string;
  selected_payment_method_id: string | null;
  saved_payment_methods: PaymentMethod[] | null;

  telegram_info: {
    first_name: string;
    last_name: string;
    username: string;
  };
};

export type TariffMode = keyof PriceRangesI["ranges"];

export type CategoryGroup = "taxi" | "eda" | "kuper";

export type Mode = {
  id: TariffMode;
  label: string;
  Icon: FC<{ active: boolean }>;
};

export const tariffModeToLayer: Record<TariffMode, string> = {
  kuper: "price_kuper",
  kuper_auto: "price_kuper_auto",
  eda_car: "price_eda_car",
  eda_velo: "price_eda_velo",
  c_cargo: "price_c_cargo",
  c_courier: "price_c_courier",
  c_express: "price_c_express",
  c_express_30min_longer: "price_c_express_30min_longer",
  t_express: "price_t_express",
  t_econom: "price_t_econom",
  t_business: "price_t_business",
  t_courier: "price_t_courier",
  t_comfortplus: "price_t_comfortplus",
  t_vip: "price_t_vip",
  t_minivan: "price_t_minivan",
};

export const isEdaTariffMode = (tariffMode: TariffMode) =>
  tariffMode.startsWith("eda_");

export const isKuperTariffMode = (tariffMode: TariffMode) =>
  tariffMode.startsWith("kuper");

export type UserFunnelStatus =
  | "START"
  | "OPEN_APP"
  | "ONBOARDING"
  | "SUBSCRIPTION";

export type Regions = {
  agglomeration_id: number;
  agglomeration_name: string;
  hexgroup_id: number;
  hexgroup_name: string;
};
